module.exports = __webpack_public_path__ + "media/images/lb/812-64e5e15bf764d704120ffb1e76373dd3.svg";